import { createSlice } from '@reduxjs/toolkit';

const serviceAccessFormSlice = createSlice({
  name: 'serviceAccessForm',
  initialState: {
    serviceForm: {},
    serviceFormIsSign: false,
    serviceFormLoaded: false
  },

  reducers: {
    setServiceFormKeysOnLoad: (state, action) => {
      const initialServices = action.payload;
      if (initialServices) {
        initialServices.forEach((category) => {
          category.services.forEach((service) => {
            state.serviceForm[service.type] = false;
          });
        });
        state.serviceFormLoaded = true;
      }
    },
    setServiceForm: (state, action) => {
      const stringSet = new Set(action.payload);
      Object.keys(state.serviceForm).forEach((key) => {
        if (stringSet.has(key)) {
          state.serviceForm[key] = true;
        } else {
          state.serviceForm[key] = false;
        }
      });
      state.serviceFormIsSign = true;
    },
  },
});

export const { setServiceFormKeysOnLoad, setServiceForm } = serviceAccessFormSlice.actions;

export default serviceAccessFormSlice.reducer;
